import { createSlice } from '@reduxjs/toolkit';

const ALL_OPTION = 'ALL';

const initialState = {
    // Data
    files: [],
    totalElements: 0,

    // Filters (dropdown options)
    clients: [ALL_OPTION],
    firms: [ALL_OPTION],

    // Loading
    loading: false,
    error: null,

    // Preview
    previewUrl: null,
    openPreview: false,
};

const documentSlice = createSlice({
    name: 'document',
    initialState,
    reducers: {
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingStopped(state) {
            state.loading = false;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },
        documentsLoaded(state, action) {
            state.files = action.payload.files;
            state.totalElements = action.payload.total;
        },
        filtersLoaded(state, action) {
            const { clients, firms } = action.payload;
            state.clients = [ALL_OPTION, ...clients.sort((a, b) => a.localeCompare(b))];
            state.firms = [ALL_OPTION, ...firms.sort((a, b) => a.localeCompare(b))];
        },
        previewUrlSet(state, action) {
            state.previewUrl = action.payload.url;
            state.openPreview = true;
        },
        previewClosed(state) {
            state.previewUrl = null;
            state.openPreview = false;
        },
    },
});

export const { actions: documentActions } = documentSlice;
export const documentReducer = documentSlice.reducer;

